export default __webpack_public_path__ + "static/media/iot.1a720b28.png";